import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react"
import { Modal, Button, message, Table } from "antd"
import { orderReviewList } from "@/service/ordersService"
import { timeShift } from "@/utils/util"
export default ({ visible, onClose, orderId }) => {
    const { t } = useTranslation();
    const [reviewList, setReviewList] = useState([])

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        let data = {
            pageSize: 1000,
            searchItem: { orderId: orderId },
            pageNum: 1,
        }
        orderReviewList(data).then((res) => {
            // if (res && res.retCode === 200) {
            setReviewList(res.retData.list)
            // } else {
            //     message.warning(res.retMsg)
            // }
        })
        // .catch((err) => message.error(err.retMsg))
    }

    //table配置
    const columns = [
        {
            title: t(`ordersManage.ordersManage.orderReviewRecord.审核人名称`),
            align: "center",
            dataIndex: "reviewerName",
        },
        {
            title: t(`ordersManage.ordersManage.orderReviewRecord.审核状态`),
            align: "center",
            dataIndex: "reviewerStatus",
            render: (text) => <>{text === "adopt" ? t(`ordersManage.ordersManage.orderReviewRecord.通过`) : text === "reject" ? t(`ordersManage.ordersManage.orderReviewRecord.驳回`) : ""}</>,
        },
        {
            title: t(`ordersManage.ordersManage.orderReviewRecord.审核时间`),
            align: "center",
            dataIndex: "reviewerTime",
            // render: (text) => (text ? timeShift(text) : ""),
        },
        {
            title: t(`ordersManage.ordersManage.orderReviewRecord.提交人名称`),
            align: "center",
            dataIndex: "submitUserName",
        },
        {
            title: t(`ordersManage.ordersManage.orderReviewRecord.驳回原因`),
            align: "center",
            dataIndex: "rejectInfo",
        },
    ]
    return (
        <Modal
            title= {t(`ordersManage.ordersManage.orderReviewRecord.工单审核记录详情`)}
            width={1000}
            visible={visible}
            onCancel={() => onClose({ visible: false, orderId: "" })}
            footer={[
                <Button onClick={() => onClose()} key="back">
                    {" "}
                    {t(`ordersManage.ordersManage.orderReviewRecord.取消`)}
                </Button>,
                <Button type="primary" onClick={() => onClose()} key="submit">
                     {t(`ordersManage.ordersManage.orderReviewRecord.确认`)}
                </Button>,
            ]}
        >
            <Table size="small" rowKey={(record) => record.id} columns={columns} dataSource={reviewList} pagination={false} scroll={{ y: 500 }} />
        </Modal>
    )
}
